<template>
  <span>
    <b-card-actions
      v-if="$permissionAbility(OUTREACH_INVOICE_CREATE, permissions)"
      title="Generate Invoice"
      action-collapse
    >
      <div>
        <!-- search input -->
        <div>
          <b-row>
            <b-col md="6" lg="4" xs="12">
              <!--              <v-select-->
              <!--                  v-model="generateSiteListId"-->
              <!--                  :options="filteredSiteListOptions"-->
              <!--                  :reduce="(item) => item.id"-->
              <!--                  label="website"-->
              <!--                  placeholder="Select Website"-->
              <!--                  class="mb-1 custom-font"-->
              <!--              >-->
              <!--                <template #option="{ website, is_disabled }">-->
              <!--                  <span-->
              <!--                      :class="{'text-muted': is_disabled, 'disabled-option': is_disabled}"-->
              <!--                      :style="is_disabled ? { pointerEvents: 'none', cursor: 'not-allowed' } : {}"-->
              <!--                  >-->
              <!--                      {{ website }}-->
              <!--                  </span>-->
              <!--              </template>-->
              <!--            </v-select>-->

              <v-select
                id="seller"
                v-model="generateSellerId"
                :options="filteredSellerOptions"
                :reduce="(option) => option.id"
                label="name"
                placeholder="Select Seller"
                @input="loadItems"
              />
            </b-col>

            <b-col lg="3">
              <b-button
                class="flex-shrink-0 ml-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="submit"
                @click="onShowGenerate()"
                :disabled="!generateSellerId"
              >
                Generate
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <b-card-actions
      v-if="$permissionAbility(OUTREACH_INVOICE_SHOW, permissions)"
      title="Filters"
      action-collapse
    >
      <div>
        <!-- search input -->
        <div>
          <b-row>
            <b-col md="3" lg="4" xs="12" class="mb-2 mb-md-0">
              <b-form-input
                v-on:keyup="onSearch"
                v-model.lazy="searchTerm"
                placeholder="Website"
                type="text"
                class="d-inline-block mr-sm-1"
              />
            </b-col>

            <b-col md="6" lg="2" xs="12" class="mb-2 mb-md-0">
              <v-select
                id="seller"
                v-model="filterSelectSellersId"
                :options="filteredSellerOptions"
                :reduce="(option) => option.id"
                label="name"
                placeholder="Select Seller"
                @input="loadItems"
              />
            </b-col>

            <b-col md="6" lg="2" xs="12" class="mb-2 mb-md-0">
              <v-select
                v-model="filterSelectStatusId"
                :options="outreachInvoiceStatusConstants"
                :reduce="(item) => item.value"
                label="name"
                placeholder="Select Status"
                class="mb-1 custom-font"
                @input="loadItems"
              />
            </b-col>

            <b-col md="6" lg="2" xs="12" class="mb-2 mb-md-0">
              <v-select
                v-model="filterPaymentMethod"
                :options="filteredPaymentOptions"
                :reduce="(item) => item.id"
                label="name"
                placeholder="Select Payment Method"
                class="mb-1 custom-font"
                @input="loadItems"
              />
            </b-col>

            <b-col md="6" lg="2" xs="12" class="mb-2 mb-md-0">
              <flat-pickr
                v-model="filterGeneratedDate"
                class="form-control"
                placeholder="Select Generated Date Range"
                :config="{
                  mode: 'range',
                  defaultDate: [
                    filterGeneratedStartDate,
                    filterGeneratedEndDate,
                  ],
                }"
                @input="loadItems"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <b-card>
      <div>
        <!-- table -->
        <vue-good-table
          v-if="$permissionAbility(OUTREACH_INVOICE_SHOW, permissions)"
          styleClass="vgt-table table-custom-style striped"
          :line-numbers="false"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :rows="rows"
          :columns="columns"
          :sort-options="{
            enabled: false,
            multipleColumns: true,
            initialSortBy: [{ field: 'created_at', type: 'desc' }],
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Back link Type  -->
            <template v-if="props?.column?.field === 'format_invoice_number'">
              <div v-if="props?.row?.invoice_number">
                <b-badge 
                  variant="light-primary"
                  @click="onShowDetails(props.row?.id)"
                  class="cursor-pointer badge-link no-wrap"
                >
                  {{ props?.row?.invoice_number }}
                </b-badge>
              </div>
              <div v-else>
                <b-badge variant="light-warning">NA</b-badge>
              </div>
            </template>

            <template v-if="props?.column?.field === 'format_website'">
              {{ formatWebsite(props?.row?.site_list?.data?.website) }}
            </template>

            <template v-if="props?.column?.field === 'seller_format'">
              <div v-if="props?.row?.seller">
                {{ props?.row?.seller?.data?.name }}
              </div>
              <div v-else>
                <b-badge variant="light-warning">NA</b-badge>
              </div>
            </template>

            <!-- Status  -->
            <template v-if="props?.column?.field === 'format_status'">
              <template v-if="!props?.row?.review">
                <b-badge variant="light-secondary"> Pending </b-badge>
              </template>
              <template v-else>
                <div v-if="props?.row?.status === paymentPaidConstants">
                  <b-badge variant="light-success">
                    {{ props?.row?.status_text }}
                  </b-badge>
                </div>
                <div v-else>
                  <b-badge variant="light-danger">
                    {{ props?.row?.status_text }}
                  </b-badge>
                </div>
              </template>
            </template>

            <template v-if="props?.column?.field === 'format_payment_method'">
              <b-badge variant="success">
                {{ props?.row?.payment_method_text }}
              </b-badge>
            </template>

            <!-- Payment Date -->
            <template v-if="props?.column?.field === 'format_payment_date'">
              <span>
                {{ formatDate(props?.row?.payment_date)}}
              </span>
            </template>

            <span v-if="props.column.field === 'action'">
              <template v-if="props.row?.review">
                <span @click="onShowDetails(props.row?.id)">
                  <feather-icon
                    v-b-tooltip.hover
                    icon="EyeIcon"
                    class="mr-50 custom-icon cursor-pointer"
                    title="View"
                    size="16"
                  />
                </span>
              </template>

              <template
                v-if="
                  $permissionAbility(
                    OUTREACH_INVOICE_ADMIN_EDIT_BEFORE_AND_AFTER_APPROVE,
                    permissions
                  ) ||
                  ($permissionAbility(OUTREACH_INVOICE_EDIT, permissions) &&
                    props.row?.status !== paymentPaidConstants)
                "
              >
                <span @click="onShow(props.row)">
                  <feather-icon
                    v-b-tooltip.hover
                    icon="Edit2Icon"
                    class="mr-50 custom-icon cursor-pointer"
                    title="Edit"
                    size="16"
                  />
                </span>
              </template>

              <template
                v-if="
                  ($permissionAbility(OUTREACH_INVOICE_REVIEW, permissions) ||
                    $permissionAbility(
                      OUTREACH_INVOICE_PROXY_REVIEW,
                      permissions
                    )) &&
                  props.row?.status !== paymentPaidConstants &&
                  !props.row?.review
                "
              >
                <span @click="onReview(props.row)">
                  <feather-icon
                    v-b-tooltip.hover
                    icon="CheckIcon"
                    class="mr-50 custom-icon cursor-pointer"
                    title="Review"
                    size="16"
                  />
                </span>
              </template>

              <template
                v-if="
                  $permissionAbility(OUTREACH_INVOICE_DELETE, permissions) &&
                  props.row?.status !== paymentPaidConstants
                "
              >
                <span @click="onDelete(props.row)">
                  <feather-icon
                    v-b-tooltip.hover
                    icon="TrashIcon"
                    class="mr-50 custom-icon cursor-pointer"
                    title="Delete"
                    size="16"
                  />
                </span>
              </template>
            </span>

            <span v-if="props.column.field === 'grand_total'">
              <b-badge variant="primary">
                {{
                  props?.row?.backlinks?.data[0]?.currency?.data?.currency || ""
                }}
                {{
                  (
                    parseFloat(props?.row?.total_amount || 0) +
                    parseFloat(props?.row?.fee_amount || 0) -
                    parseFloat(props?.row?.discount_amount || 0)
                  ).toFixed(2)
                }}
              </b-badge>
            </span>
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '25', '50', '100', '500']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>

      <b-modal
        id="modal-invoice-generate-form"
        centered
        :title="
          modelType === 'reviewModal'
            ? 'Review Invoice'
            : modelType === 'editModel'
            ? 'Edit Invoice'
            : 'Generate Invoice'
        "
        hide-footer
        @hidden="hiddenGenerateModal"
        size="xl"
        no-close-on-backdrop
      >
        <validation-observer ref="generateInvoiceForm">
          <b-form v-on:submit.prevent="generateInvoiceForm">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Seller"
                  label-for="seller"
                  class="required-label"
                >
                  <v-select
                    v-model="generateSellerId"
                    :options="filteredSellerOptions"
                    :reduce="(item) => item.id"
                    label="name"
                    placeholder="Select Seller"
                    class="mb-1 custom-font"
                    disabled
                  />
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <!-- payment_method -->
                <b-form-group
                  label="Payment Method"
                  label-for="payment_method"
                  class="required-label"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="payment method"
                    vid="payment_method"
                    rules="required"
                  >
                    <v-select
                      id="payment_method"
                      v-model="selectPaymentId"
                      :options="filteredPaymentOptions"
                      :reduce="(option) => option.id"
                      label="name"
                      placeholder="Choose Here"
                      :disabled="
                        !$permissionAbility(
                          OUTREACH_INVOICE_EDIT,
                          permissions
                        ) && modelType === 'reviewModal'
                      "
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <!-- approver_id -->
                <b-form-group label="Approver" label-for="approver_id">
                  <validation-provider
                    #default="{ errors }"
                    name="Approver"
                    vid="approver_id"
                    rules="required"
                  >
                    <v-select
                      id="approver_id"
                      v-model="selectApproverId"
                      :options="filteredApproverOptions"
                      :reduce="(option) => option.id"
                      label="name"
                      placeholder="Choose Here"
                      :disabled="
                        !$permissionAbility(
                          OUTREACH_INVOICE_EDIT,
                          permissions
                        ) && modelType === 'reviewModal'
                      "
                    >
                      <template #option="data">
                        <UserSelect :user="data" />
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" lg="12" xs="12">
                <template v-if="unpaidBackLink.length > 0">
                  <b-table
                    :items="unpaidBackLink"
                    :fields="backLinkFields"
                    class="mb-0 backlinks-table"
                  >
                    <template #cell(backlink)="data">
                      <div>
                        <!-- Backlink -->
                        <b>Backlink:</b>
                        <a
                          :href="
                            data.item?.site_list?.website +
                            '/' +
                            data.item.backlink_url
                          "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ formatWebsite(data.item.backlink_url) }}
                        </a>
                      </div>
                      <div>
                        <!-- Targeted URL -->
                        <b>URL:</b>
                        <a
                          :href="data.item.targeted_url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ formatWebsite(data.item.targeted_url) }}
                        </a>

                        <div>
                          <b>Project</b>: {{ data.item.project?.data?.title }}
                        </div>
                      </div>
                    </template>

                    <template #cell(project)="data">
                      <b-badge variant="light-primary">
                        {{ data.item.project?.data?.title }}
                      </b-badge>
                    </template>

                    <template #cell(type)="data">
                      <b-badge variant="light-primary" v-if="data.item.backlinks_type_text != ''">
                        {{ data.item.backlinks_type_text }}
                      </b-badge>
                      <b-badge variant="light-secondary" v-else>
                        N/A
                      </b-badge>
                    </template>

                    <template #cell(status)="data">
                      <template
                        v-if="
                          modelType === 'reviewModal' &&
                          $permissionAbility(BACK_LINK_REVIEW, permissions)
                        "
                      >
                        <v-select
                          v-model="data.item.status"
                          :options="outreachStatusConstants"
                          :reduce="(item) => item.value"
                          label="name"
                          placeholder="Select Status"
                          class="mb-1 custom-font"
                          @input="
                            backlinkStatusUpdate(data.item.id, data.item.status)
                          "
                        />
                      </template>
                      <template v-else>
                        <b-badge :variant="getStatusVariant(data.item.status)">
                          {{ data.item.status_text }}
                        </b-badge>
                      </template>
                    </template>
                    <template #cell(price)="data">
                      {{ data.item.currency?.data?.currency }}
                      {{ parseFloat(data.item.cost_price || 0).toFixed(2) }}
                    </template>
                    <template #cell(discount)="data">
                      <div class="discount-column" v-if="data.item.cost_price > 0">
                        <validation-observer
                          :ref="`discountObserver_${data.item.id}`"
                          #default="{ invalid: isInvalid }"
                        >
                          <v-select
                            v-model="data.item.discount_type"
                            :options="discountTypeOptions"
                            :reduce="(item) => item.value"
                            label="name"
                            placeholder="Type"
                            class="mb-1 custom-font"
                            size="sm"
                            :disabled="
                              !$permissionAbility(
                                OUTREACH_INVOICE_EDIT,
                                permissions
                              ) && modelType === 'reviewModal'
                            "
                            @input="handleDiscountTypeChange(data.item)"
                          />

                          <b-form-group
                            v-if="data.item.discount_type && data.item.discount_type === 'percentage'"
                            label=""
                            label-for="discountValue"
                            class="mb-1"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Discount Value"
                              :vid="`backlink_discount_value_${data.item.id}`"
                              rules="required|min_value:0|max_value:100"
                              :messages="{
                                required: 'Discount value is required',
                                min_value: 'Discount value must be at least 0',
                                max_value: 'Discount value cannot exceed 100%'
                              }"
                            >
                              <b-form-input
                                type="number"
                                v-model="data.item.discount_value"
                                placeholder="Value %"
                                size="sm"
                                step="any"
                                :state="errors.length > 0 ? false : null"
                                :disabled="
                                  !$permissionAbility(
                                    OUTREACH_INVOICE_EDIT,
                                    permissions
                                  ) && modelType === 'reviewModal'
                                "
                                @input="recalculatePercentageDiscount(data.item)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>

                          <b-form-group
                            v-if="data.item.discount_type"
                            label=""
                            label-for="discountAmount"
                            class="mb-2"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Discount Amount"
                              :vid="`backlink_discount_amount_${data.item.id}`"
                              :rules="
                                (data.item.discount_type === 'flat' ? 'required|' : '') +
                                'min_value:0|max_value:' +
                                parseFloat(data.item.cost_price || 0)
                              "
                              :messages="{
                                required: 'Discount amount is required for flat discounts',
                                min_value: 'Discount cannot be negative',
                                max_value: 'Discount cannot exceed the cost price'
                              }"
                            >
                              <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    {{ data.item.currency?.data?.currency }}
                                  </span>
                                </div>
                                <b-form-input
                                  type="number"
                                  v-model="data.item.discount_amount"
                                  placeholder="Amount"
                                  step="any"
                                  :state="errors.length > 0 ? false : null"
                                  :disabled="
                                    data.item.discount_type === 'percentage' &&
                                    !$permissionAbility(
                                      OUTREACH_INVOICE_EDIT,
                                      permissions
                                    ) &&
                                    modelType === 'reviewModal'
                                  "
                                  @input="handleFlatDiscountAmountChange(data.item)"
                                />
                              </div>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>

                          <!-- Save button for discount -->
                          <b-button
                            v-if="
                              $permissionAbility(
                                OUTREACH_INVOICE_EDIT,
                                permissions
                              ) ||
                              (modelType !== 'reviewModal')
                            "
                            variant="success"
                            size="sm"
                            class="w-100"
                            :disabled="backlinksLoadingState[data.item.id] || !hasDiscountChanged(data.item) || isInvalid"
                            @click="updateBackLinkDiscount(data.item)"
                          >
                            <b-spinner
                              v-if="backlinksLoadingState[data.item.id]"
                              small
                              class="mr-1"
                            />
                            <feather-icon
                              v-else
                              icon="SaveIcon"
                              size="14"
                              class="mr-1"
                            />
                            {{ backlinksLoadingState[data.item.id] ? "Saving..." : "Save" }}
                          </b-button>
                        </validation-observer>
                      </div>
                      <div v-else>
                        <b-badge variant="light-secondary"> Not applicable </b-badge>
                      </div>
                    </template>
                    <template #cell(discount_amount)="data">
                      <div v-if="data.item.cost_price > 0 && data.item.discount_amount">
                        <div class="d-flex align-items-center">
                          <span class="mr-2">{{ data.item.currency?.data?.currency }}</span>
                          <strong>{{ parseFloat(data.item.discount_amount || 0).toFixed(2) }}</strong>
                        </div>
                      </div>
                      <div v-else>
                        <b-badge variant="light-secondary">NA</b-badge>
                      </div>
                    </template>
                    <template #cell(subtotal)="data">
                      <div v-if="data.item.cost_price > 0">
                        <div class="d-flex align-items-center">
                          <span class="mr-2">{{ data.item.currency?.data?.currency }}</span>
                          <strong>{{ parseFloat((data.item.cost_price || 0) - (data.item.discount_amount || 0)).toFixed(2) }}</strong>
                        </div>
                      </div>
                      <div v-else>
                        <b-badge variant="light-secondary">N/A</b-badge>
                      </div>
                    </template>
                    <template #cell(action)="data">
                      <b-button
                        v-if="
                          modelType !== 'reviewModal' ||
                          ($permissionAbility(
                            OUTREACH_INVOICE_EDIT,
                            permissions
                          ) &&
                            modelType === 'reviewModal')
                        "
                        variant="danger"
                        size="sm"
                        @click="unselectBacklink(data.index)"
                      >
                        X
                      </b-button>
                      <template v-else>
                        <b-badge variant="light-danger"> N/A </b-badge>
                      </template>
                    </template>
                  </b-table>
                </template>
                <template v-else>
                  <h6 class="text-danger">No Unpaid Backlink</h6>
                </template>

                <div class="d-flex justify-content-end mr-5 mb-1">
                  <div>
                    <h4>
                      Total Amount:
                      {{ unpaidBackLink[0]?.currency?.data?.currency }}
                      {{ parseFloat(total_amount || 0).toFixed(2) }}
                    </h4>

                    <v-select
                      v-model="fee_type"
                      :options="discountTypeOptions"
                      :reduce="(item) => item.value"
                      label="name"
                      placeholder="Fee Type"
                      class="mb-1 custom-font"
                      @input="feeTypeChange"
                      :disabled="
                        !$permissionAbility(
                          OUTREACH_INVOICE_EDIT,
                          permissions
                        ) && modelType === 'reviewModal'
                      "
                    />

                    <b-form-group
                      v-if="fee_type && fee_type === 'percentage'"
                      label=""
                      label-for="Fee"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="fee value"
                        vid="fee_value"
                        :rules="
                          fee_type === 'percentage'
                            ? 'required|min_value:0|max_value:100'
                            : 'min_value:0|max_value:100'
                        "
                      >
                        <b-form-input
                          id="fee_value"
                          type="number"
                          v-model="fee_value"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Fee Value"
                          @input="calculateGrandTotal"
                          @change="calculateGrandTotal"
                          step="any"
                          :disabled="
                            !$permissionAbility(
                              OUTREACH_INVOICE_EDIT,
                              permissions
                            ) && modelType === 'reviewModal'
                          "
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group v-if="fee_type" label="" label-for="Fee">
                      <validation-provider
                        #default="{ errors }"
                        name="fee amount"
                        vid="fee_amount"
                        :rules="
                          fee_type === 'flat'
                            ? 'required|min_value:0'
                            : 'min_value:0'
                        "
                      >
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              id="spamScoreAddon"
                              >{{
                                unpaidBackLink[0]?.currency?.data?.currency
                              }}</span
                            >
                          </div>
                          <b-form-input
                            id="discount_amount"
                            type="number"
                            v-model="fee_amount"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Fee Amount"
                            @input="calculateGrandTotal"
                            step="any"
                            :disabled="
                              fee_type === 'percentage' &&
                              !$permissionAbility(
                                OUTREACH_INVOICE_EDIT,
                                permissions
                              ) &&
                              modelType === 'reviewModal'
                            "
                          />
                        </div>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <!--                  Fee Calculation Ends here-->

                    <!--                  Discount calculation start here-->
                    <v-select
                      v-model="discount_type"
                      :options="discountTypeOptions"
                      :reduce="(item) => item.value"
                      label="name"
                      placeholder="Discount Type"
                      class="mb-1 custom-font"
                      @input="discountTypeChange"
                      :disabled="
                        !$permissionAbility(
                          OUTREACH_INVOICE_EDIT,
                          permissions
                        ) && modelType === 'reviewModal'
                      "
                    />

                    <b-form-group
                      v-if="discount_type && discount_type === 'percentage'"
                      label=""
                      label-for="Discount"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="discount value"
                        vid="discount_value"
                        :rules="
                          discount_type === 'percentage'
                            ? 'required|min_value:0|max_value:100'
                            : 'min_value:0|max_value:100'
                        "
                      >
                        <b-form-input
                          id="discount_value"
                          type="number"
                          v-model="discount_value"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Discount Value"
                          @input="calculateGrandTotal"
                          step="any"
                          :disabled="
                            !$permissionAbility(
                              OUTREACH_INVOICE_EDIT,
                              permissions
                            ) && modelType === 'reviewModal'
                          "
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group
                      v-if="discount_type"
                      label=""
                      label-for="Discount"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="discount amount"
                        vid="discount_amount"
                        :rules="
                          (discount_type === 'flat' ? 'required|' : '') +
                          'min_value:0|max_value:' +
                          (parseFloat(total_amount) +
                            (fee_amount ? parseFloat(fee_amount) : 0))
                        "
                      >
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              id="spamScoreAddon"
                              >{{
                                unpaidBackLink[0]?.currency?.data?.currency
                              }}</span
                            >
                          </div>
                          <b-form-input
                            id="discount_amount"
                            type="number"
                            v-model="discount_amount"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Discount Amount"
                            @input="calculateGrandTotal"
                            step="any"
                            :disabled="
                              discount_type === 'percentage' &&
                              !$permissionAbility(
                                OUTREACH_INVOICE_EDIT,
                                permissions
                              ) &&
                              modelType === 'reviewModal'
                            "
                          />
                        </div>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <h4>
                      Grand Total:
                      {{ unpaidBackLink[0]?.currency?.data?.currency }}
                      {{ parseFloat(grand_total || 0).toFixed(2) }}
                    </h4>
                  </div>
                </div>
              </b-col>

              <template v-if="unSelectedUnpaidBackLink.length > 0">
                <h4 class="m-2">Unselected</h4>
                <b-col cols="12" lg="12" xs="12">
                  <template v-if="unSelectedUnpaidBackLink.length > 0">
                    <b-table
                      responsive
                      :items="unSelectedUnpaidBackLink"
                      :fields="backLinkFields"
                      class="mb-0"
                    >
                      <template #cell(backlink)="data">
                        <div>
                          <!-- Backlink -->
                          <b>Backlink:</b>
                          <a
                            :href="
                              data.item?.site_list?.website +
                              '/' +
                              data.item.backlink_url
                            "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ formatWebsite(data.item.backlink_url) }}
                          </a>
                        </div>
                        <div>
                          <!-- Targeted URL -->
                          <b>URL:</b>
                          <a
                            :href="data.item.targeted_url"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ formatWebsite(data.item.targeted_url) }}
                          </a>

                          <div>
                            <b>Project</b>: {{ data.item.project?.data?.title }}
                          </div>
                        </div>
                      </template>

                      <template #cell(project)="data">
                        <b-badge variant="light-primary">
                          {{ data.item.project?.data?.title }}
                        </b-badge>
                      </template>

                      <template #cell(type)="data">
                        <b-badge variant="light-primary">
                          {{ data.item.backlinks_type_text }}
                        </b-badge>
                      </template>

                      <template #cell(status)="data">
                        <b-badge :variant="getStatusVariant(data.item.status)">
                          {{ data.item.status_text }}
                        </b-badge>
                      </template>

                      <template #cell(price)="data">
                        <b-badge variant="light-success"
                          >{{ data.item.currency?.data?.currency }}
                          {{
                            parseFloat(data.item.cost_price || 0).toFixed(2)
                          }}</b-badge
                        >
                      </template>

                      <template #cell(action)="data">
                        <b-button
                          v-if="
                            modelType !== 'reviewModal' ||
                            ($permissionAbility(
                              OUTREACH_INVOICE_EDIT,
                              permissions
                            ) &&
                              modelType === 'reviewModal')
                          "
                          variant="success"
                          size="sm"
                          @click="selectUnselectedBacklink(data.index)"
                        >
                          <feather-icon
                            v-b-tooltip.hover
                            icon="CheckIcon"
                            title="Select"
                            size="16"
                        /></b-button>
                      </template>
                    </b-table>
                  </template>
                  <template v-else>
                    <h6 class="text-danger">No Unselected Unpaid Backlink</h6>
                  </template>
                </b-col>
              </template>

              <b-col md="6" lg="6" xs="12" class="mb-10">
                <b-form-group
                  label="Payment Details"
                  label-for="payment_details"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Payment Details"
                    vid="payment_details"
                  >
                    <div :class="{ fullscreen: isFullscreen }">
                      <quill-editor
                        v-model="paymentDetailsInput"
                        :options="editorOption"
                        :style="{
                          width: '98% !important',
                        }"
                        id="payment_details"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Payment Details"
                        class="custom-quill-editor"
                        :disabled="
                          !$permissionAbility(
                            OUTREACH_INVOICE_EDIT,
                            permissions
                          ) && modelType === 'reviewModal'
                        "
                      >
                        <div id="toolbar" slot="toolbar">
                          <!-- Add a bold button -->
                          <span class="ql-formats">
                            <button class="ql-bold">Bold</button>
                            <button class="ql-italic">Italic</button>
                            <button class="ql-underline">Underline</button>
                            <button class="ql-strike">Strike</button>
                            <button class="ql-blockquote"></button>
                            <button class="ql-list" value="ordered"></button>
                            <button class="ql-list" value="bullet"></button>
                            <button class="ql-script" value="sub"></button>
                            <button class="ql-script" value="super"></button>
                            <button class="ql-indent" value="-1"></button>
                            <button class="ql-indent" value="+1"></button>
                            <button class="ql-direction" value="rtl"></button>
                            <button class="ql-align" value=""></button>
                            <button class="ql-align" value="center"></button>
                            <button class="ql-align" value="right"></button>
                            <button class="ql-align" value="justify"></button>
                            <select class="ql-color"></select>
                            <select class="ql-background"></select>
                            <select class="ql-size">
                              <option value="small" />

                              <option selected />
                              <option value="large" />
                              <option value="huge" />
                            </select>

                            <select class="ql-font"></select>
                            <select class="ql-header">
                              <option value="1">Heading 1</option>
                              <option value="2">Heading 2</option>
                              <option value="3">Heading 3</option>
                              <option value="4">Heading 4</option>
                              <option value="5">Heading 5</option>
                              <option value="6">Heading 6</option>
                              <option selected>Normal</option>
                            </select>

                            <button class="ql-link"></button>
                            <button
                              type="button"
                              :title="
                                isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'
                              "
                              class="fullscreen-btn"
                              @click="toggleFullscreen"
                            >
                              🔳
                            </button>
                          </span>
                        </div>
                      </quill-editor>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col md="6" lg="6" xs="12">
                <!-- remarks -->
                <b-form-group label="Terms & Conditions" label-for="remarks">
                  <validation-provider
                    #default="{ errors }"
                    name="Remarks"
                    vid="remarks"
                  >
                    <b-form-textarea
                      id="remarks"
                      v-model="remarksInput"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Terms & Conditions"
                      rows="3"
                      :disabled="
                        !$permissionAbility(
                          OUTREACH_INVOICE_EDIT,
                          permissions
                        ) && modelType === 'reviewModal'
                      "
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- loading button -->
            <template v-if="isSubmitLoading">
              <b-button class="float-right" variant="primary" disabled>
                <b-spinner small />
                Loading...
              </b-button>
            </template>

            <!-- submit button -->
            <template v-else>
              <template v-if="modelType === 'reviewModal'">
                <b-button
                  :disabled="!payment_active || unpaidBackLink.length <= 0"
                  type="submit"
                  class="float-right"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  >Proceed to Payment</b-button
                >
              </template>
              <template v-else>
                <b-button
                  :disabled="unpaidBackLink.length <= 0"
                  type="submit"
                  class="float-right"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  >{{
                    modelType === "editModel" ? "Update" : "Generate"
                  }}</b-button
                >
              </template>
            </template>
          </b-form>
        </validation-observer>
      </b-modal>
    </b-card>
  </span>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BRow,
  BCol,
  VBTooltip,
  BFormDatepicker,
  BFormTextarea,
  BTable,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { quillEditor } from "vue-quill-editor";
import { required, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import UserAssignPolicyForm from "@/views/admin/payroll-management/UserAssignPolicyForm.vue";
import UserSelect from "@/layouts/components/UserSelect.vue";
import {
  OUTREACH_INVOICE_ACCESS,
  OUTREACH_INVOICE_CREATE,
  OUTREACH_INVOICE_EDIT,
  OUTREACH_INVOICE_ADMIN_EDIT_BEFORE_AND_AFTER_APPROVE,
  OUTREACH_INVOICE_DELETE,
  OUTREACH_INVOICE_SHOW,
  OUTREACH_INVOICE_REVIEW,
  OUTREACH_INVOICE_PROXY_REVIEW,
  BACK_LINK_REVIEW,
  OUTREACH_INVOICE_PAYMENT,
} from "@/helpers/permissionsConstant";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  paymentPaidConstants,
  paymentUnpaidConstants,
  paymentDueConstants,
  outreachInvoiceStatusConstants,
} from "@/helpers/constant/outreachPaymentStatusConstant";
import {
  approvedStatusConstants,
  pendingStatusConstants,
  rejectedStatusConstants,
  softRejectedStatusConstants,
  outreachStatusConstants,
} from "@/helpers/constant/outreachStatusConstant";
import flatPickr from "vue-flatpickr-component";
import { formatDateRange, formatDate } from "@/helpers/helpers";

export default {
  name: "OutreachInvoiceView",
  components: {
    BTable,
    BCardActions,
    UserAssignPolicyForm,
    BForm,
    flatPickr,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BRow,
    BCol,
    VBTooltip,
    BFormDatepicker,
    BFormTextarea,
    UserSelect,
    quillEditor,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  watch: {
    unpaidBackLink(newValue) {
      this.total_amount = 0;
      this.total_amount = this.unpaidBackLink.reduce((sum, item) => {
        return sum + ((item.cost_price || 0) - (parseFloat(item.discount_amount) || 0));
      }, 0);

      this.payment_active = false;
      this.payment_active = this.unpaidBackLink.every(
        (item) => item.status === this.approvedStatusConstants
      );

      // Initialize original discount state for change detection
      this.backlinksOriginalDiscount = {};
      this.unpaidBackLink.forEach((backlink) => {
        this.backlinksOriginalDiscount[backlink.id] = {
          discount_type: backlink.discount_type || "",
          discount_value: backlink.discount_value || 0,
          discount_amount: backlink.discount_amount || 0,
        };
      });
    },
    total_amount() {
      this.calculateGrandTotal();
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },

      // Permissions
      OUTREACH_INVOICE_ACCESS,

      OUTREACH_INVOICE_CREATE,
      OUTREACH_INVOICE_EDIT,
      OUTREACH_INVOICE_ADMIN_EDIT_BEFORE_AND_AFTER_APPROVE,
      OUTREACH_INVOICE_DELETE,
      OUTREACH_INVOICE_SHOW,
      OUTREACH_INVOICE_REVIEW,
      OUTREACH_INVOICE_PROXY_REVIEW,
      OUTREACH_INVOICE_PAYMENT,
      BACK_LINK_REVIEW,

      outreachInvoiceStatusConstants,
      paymentPaidConstants,
      paymentUnpaidConstants,
      paymentDueConstants,

      outreachStatusConstants,

      approvedStatusConstants,
      pendingStatusConstants,
      rejectedStatusConstants,
      softRejectedStatusConstants,

      filterSelectSellersId: "",
      filterSelectStatusId: "",
      filterGeneratedDate: "",
      filterGeneratedStartDate: "",
      filterGeneratedEndDate: "",
      filterPaymentMethod: "",

      payment_active: true,
      filterSelectWebsiteId: "",
      generateSiteListId: "",
      generateSellerId: "",
      filteredSiteListOptions: [],
      filteredSellerOptions: [],
      unpaidBackLink: [],
      total_amount: 0,
      grand_total: 0,
      fee_amount: "",
      discount_amount: "",
      discount_value: "",
      discount_type: "",

      fee_value: "",
      fee_type: "",

      unSelectedUnpaidBackLink: [],
      backLinkFields: ["backlink", "type", "status", "price", "discount", "discount_amount", "subtotal", "action"],

      discountTypeOptions: [
        { value: "percentage", name: "Percentage" },
        { value: "flat", name: "Flat" },
      ],

      // invoice
      invoiceNumberInput: "",
      invoiceDateInput: "",
      selectSellerId: "",
      selectPaymentId: "",
      filteredPaymentOptions: [
        { id: "paypal", name: "PayPal" },
        { id: "cash", name: "Cash" },
        { id: "mobile_banking", name: "Mobile banking" },
        { id: "crypto", name: "Crypto" },
        { id: "payoneer", name: "Payoneer" },
        { id: "bank", name: "Bank Transfer" },
      ],
      paymentDateInput: "",
      selectInvoiceStatusId: "",
      filteredInvoiceStatusOptions: [
        { id: 0, name: "Pending" },
        { id: 1, name: "Awaiting Finance Approval" },
        { id: 2, name: "Paid" },
        { id: 3, name: "Rejected" },
      ],
      paymentDetailsInput: "",
      remarksInput: "",
      backLinkId: "",

      modelType: "",
      name: "",

      outreachInvoiceId: "",
      nicheName: "",

      selectApproverId: "",
      filteredApproverOptions: [],

      //table
      pageLength: 10,
      columns: [
        {
          label: "Invoice Number",
          field: "format_invoice_number",
          sortable: false,
        },
        {
          label: "Seller",
          field: "seller_format",
          sortable: false,
        },
        {
          label: "Payment Method",
          field: "format_payment_method",
          sortable: false,
        },
        {
          label: "Status",
          field: "format_status",
          sortable: false,
        },
        {
          label: "Payment Date",
          field: "format_payment_date",
          sortable: false,
        },
        {
          label: "Generated Date",
          field: "created_at",
          formatFn: this.formatDate,
          sortable: false,
        },
        {
          label: "Grand Total",
          field: "grand_total",
          sortable: false,
        },

        {
          label: "Action",
          field: "action",
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: "",
      delayTimer: null,
      isLoading: false,
      isSubmitLoading: false,
      backlinksLoadingState: {}, // Track loading state for each backlink discount update
      backlinksOriginalDiscount: {}, // Track original discount values to detect changes
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          { field: "id", type: "desc" },
          { field: "created_at", type: "desc" },
        ],
        page: 1,
        perPage: 10,
      },
      isFullscreen: false,
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
      user: "userModule/getUser",
    }),
    statusVariant() {
      const statusColor = {
        true: "light-success",
        false: "light-danger",
      };

      return (status) => statusColor[status];
    },
  },

  async created() {
    try {
      await Promise.all([
        this.getAllSellers(),
        this.getAllApprovers(),
      ]);
      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },

  methods: {
    async getAllSellers() {
      try {
        const response = await this.$api.get("api/outreach/seller/all");

        this.filteredSellerOptions = (response?.data?.data || []).map(
          (item) => {
            let name = item.name;
            return {
              name,
              id: item.id,
            };
          }
        );
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "BellIcon",
            variant: "danger",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    discountTypeChange() {
      this.discount_amount = "";
      this.discount_value = "";
      this.calculateGrandTotal();
    },

    feeTypeChange() {
      this.fee_amount = "";
      this.fee_value = "";
      this.calculateGrandTotal();
    },

    calculateGrandTotal() {
      let grandTotal = this.total_amount;
      // Apply fee

      if (!this.fee_value) {
        this.fee_value = 0;
      }

      if (!this.discount_value) {
        this.discount_value = 0;
      }

      if (this.fee_type === "percentage") {
        // If it's a percentage, calculate the discount on the total amount
        this.fee_amount = parseFloat(
          ((parseFloat(this.fee_value) / 100) * grandTotal).toFixed(2)
        );
        grandTotal += this.fee_amount;
      } else if (this.fee_amount) {
        grandTotal += parseFloat(this.fee_amount);
      }

      // Apply discount
      if (this.discount_type === "percentage") {
        // If it's a percentage, calculate the discount on the total amount
        this.discount_amount = parseFloat(
          ((parseFloat(this.discount_value) / 100) * grandTotal).toFixed(2)
        );
        grandTotal -= this.discount_amount;
      } else if (this.discount_amount) {
        // If it's a fixed discount amount, subtract that
        grandTotal -= parseFloat(this.discount_amount);
      }

      // Store the final calculated grand total
      this.grand_total = parseFloat(grandTotal.toFixed(2));
    },

    async backlinkStatusUpdate(id, status) {
      await this.$api.put(`/api/backlinks/${id}/status`, { status: status });
      const invoice = await this.$api.get(
        `/api/outreach-invoices/${this.outreachInvoiceId}?include=backlinks,backlinks.project, backlinks.currency`
      );
      this.unpaidBackLink = [];
      this.unpaidBackLink = invoice?.data?.data?.backlinks?.data;

      await this.showGenerateModal();
    },

    unselectBacklink(index) {
      // Remove the item at the given index
      const item = this.unpaidBackLink.splice(index, 1)[0];
      this.unSelectedUnpaidBackLink.push(item);
    },

    selectUnselectedBacklink(index) {
      // Remove the item at the given index
      const item = this.unSelectedUnpaidBackLink.splice(index, 1)[0];
      this.unpaidBackLink.push(item);
    },

    getStatusVariant(status) {
      // Map status to badge variants
      switch (status) {
        case this.approvedStatusConstants:
          return "light-success";
        case this.pendingStatusConstants:
          return "light-warning";
        case this.rejectedStatusConstants:
          return "light-danger";
        default:
          return "light-secondary"; // Default variant
      }
    },

    formatWebsite(website) {
      return website;
      const maxLength = 20;
      if (website.length > maxLength) {
        return website.slice(0, maxLength) + "...";
      }
      return website;
    },

    showModal() {
      this.$bvModal.show("modal-create-form");
    },

    hiddenModal() {
      this.$bvModal.hide("modal-create-form");
      this.resetModal();
    },

    resetModal() {
      this.modelType = "";
      this.outreachInvoiceId = "";

      this.nicheName = "";
      this.invoiceNumberInput = "";
      this.invoiceDateInput = "";
      this.selectSellerId = "";
      this.selectPaymentId = "";
      this.paymentDateInput = "";
      this.selectInvoiceStatusId = "";
      this.paymentDetailsInput = "";
      this.remarksInput = "";
      this.backLinkId = "";
      this.selectApproverId = "";
    },

    onShow(value) {
      this.$nextTick(async () => {
        this.modelType = "editModel";
        this.outreachInvoiceId = value.id;

        this.unSelectedUnpaidBackLink = [];
        this.unpaidBackLink = [];

        this.unpaidBackLink = value.backlinks.data;

        this.generateSiteListId = value.site_list_id
          ? Number(value.site_list_id)
          : "";
        this.generateSellerId = value.seller_id ? Number(value.seller_id) : "";
        this.selectPaymentId = value.payment_method || "";
        this.paymentDateInput = value.payment_date;
        this.selectApproverId = value.approver_id
          ? Number(value.approver_id)
          : "";
        this.paymentDetailsInput = value.payment_details;
        this.remarksInput = value.remarks;

        this.total_amount = value.total_amount;
        this.fee_amount = value.fee_amount;
        this.discount_amount = value.discount_amount;
        this.discount_value = value.discount_value;
        this.discount_type = value.discount_type;

        this.fee_value = value.fee_value;
        this.fee_type = value.fee_type;

        await this.onShowGenerate();
      });
    },

    onReview(value) {
      this.$nextTick(() => {
        this.modelType = "reviewModal";
        this.outreachInvoiceId = value.id;

        this.unSelectedUnpaidBackLink = [];

        this.unpaidBackLink = value.backlinks.data;

        this.generateSellerId = value.seller_id ? Number(value.seller_id) : "";
        this.selectPaymentId = value.payment_method || "";
        this.paymentDateInput = value.payment_date;
        this.selectApproverId = value.approver_id
          ? Number(value.approver_id)
          : "";
        this.paymentDetailsInput = value.payment_details;
        this.remarksInput = value.remarks;

        this.total_amount = value.total_amount;
        this.fee_amount = value.fee_amount;
        this.discount_amount = value.discount_amount;
        this.discount_value = value.discount_value;
        this.discount_type = value.discount_type;

        this.fee_value = value.fee_value;
        this.fee_type = value.fee_type;

        this.showGenerateModal();
      });
    },

    onShowDetails(id) {
      const routeData = this.$router.resolve({
        name: "outreach-invoice-details",
        params: { id },
      });

      window.open(routeData.href, "_blank");
    },

    async onShowGenerate() {
      const response = await this.$api.get(
        "api/backlinks/approved-unpaid/" +
          this.generateSellerId +
          "?include=project,currency"
      );

      if (this.modelType !== "editModel") {
        this.unSelectedUnpaidBackLink = [];
        this.unpaidBackLink = response.data.data;
      } else {
        const invoice = await this.$api.get(
          `/api/outreach-invoices/${this.outreachInvoiceId}?include=backlinks,backlinks.project, backlinks.currency`
        );
        this.unpaidBackLink = [];
        this.unpaidBackLink = invoice?.data?.data?.backlinks?.data;

        this.unSelectedUnpaidBackLink = response.data.data;
      }

      this.showGenerateModal();
    },

    showGenerateModal() {
      this.$bvModal.show("modal-invoice-generate-form");
    },

    hiddenGenerateModal() {
      this.$bvModal.hide("modal-invoice-generate-form");
      this.resetGenerateModal();
    },

    resetGenerateModal() {
      this.modelType = "";
      this.generateSellerId = "";
      this.generateSiteListId = "";
      this.selectPaymentId = "";
      this.paymentDateInput = "";
      this.selectApproverId = "";
      this.remarksInput = "";
      this.paymentDetailsInput = "";
      this.unpaidBackLink = [];
      this.total_amount = 0;
      this.grand_total = 0;
      this.fee_amount = "";
      this.discount_amount = "";
      this.discount_value = "";
      this.discount_type = "";

      this.fee_value = "";
      this.fee_type = "";
    },

    async getFilteredSiteListOptions() {
      try {
        const response = await this.$api.get(
          "/api/outreach/site-list/all/approved"
        );

        this.filteredSiteListOptions = (response.data.data || []).map(
          (item) => {
            let website = item.website;
            let is_disabled = item.is_disabled;
            return {
              id: item.id,
              approveforNiches: item.approveforNiches,
              website,
              is_disabled,
            };
          }
        );
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "BellIcon",
            variant: "danger",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    async getAllApprovers() {
      try {
        const response = await this.$api.get("api/outreach-invoices/reviewers");

        this.filteredApproverOptions = (response?.data?.data || []).map(
          (item) => ({
            avatar: item?.avatar,
            name: item?.name,
            email: item?.email,
            mobile: item?.mobile,
            employee_number: item?.employee_number,
            id: item?.id,
            departmentId: item?.department_id,
          })
        );
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "BellIcon",
            variant: "danger",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    /**
     * Check if discount has changed for a backlink
     * @param {object} backlink - The backlink object
     * @returns {boolean} True if discount values have changed and discount_type is not empty
     */
    hasDiscountChanged(backlink) {
      const original = this.backlinksOriginalDiscount[backlink.id];
      if (!original) return false;

      return (
        backlink.discount_type !== original.discount_type ||
        backlink.discount_value !== original.discount_value ||
        backlink.discount_amount !== original.discount_amount
      );
    },

    /**
     * Handle discount type change - clear other fields if type is cleared
     * For flat type: discount_amount equals discount_value
     * @param {object} backlink - The backlink object
     */
    handleDiscountTypeChange(backlink) {
      // If discount type is cleared, reset discount value and amount
      if (!backlink.discount_type) {
        backlink.discount_value = 0;
        backlink.discount_amount = 0;
      } else if (backlink.discount_type === 'flat') {
        // For flat discount: discount_amount should equal discount_value
        backlink.discount_amount = backlink.discount_value || 0;
      }
      this.recalculateTotalAmount();
    },

    /**
     * Live recalculate discount amount when discount value changes for percentage type
     * Also recalculate total_amount and grand_total
     * discount_amount = (discount_value / 100) * cost_price
     * @param {object} backlink - The backlink object
     */
    recalculatePercentageDiscount(backlink) {
      if (backlink.discount_type === 'percentage') {
        const discountValue = parseFloat(backlink.discount_value) || 0;
        const costPrice = parseFloat(backlink.cost_price) || 0;
        backlink.discount_amount = parseFloat(
          ((discountValue / 100) * costPrice).toFixed(2)
        );
      }
      // Recalculate total amount based on all backlinks
      this.recalculateTotalAmount();
    },

    /**
     * Handle flat discount amount change - sync discount_value with discount_amount
     * Also recalculate total_amount and grand_total
     * For flat type: discount_value = discount_amount (they should always be equal)
     * @param {object} backlink - The backlink object
     */
    handleFlatDiscountAmountChange(backlink) {
      if (backlink.discount_type === 'flat') {
        // For flat discount: discount_value should equal discount_amount
        backlink.discount_value = backlink.discount_amount || 0;
      }
      // Recalculate total amount based on all backlinks
      this.recalculateTotalAmount();
    },

    /**
     * Recalculate total amount from all backlinks
     * total_amount = sum of (cost_price - discount_amount) for all backlinks
     */
    recalculateTotalAmount() {
      this.total_amount = 0;
      this.total_amount = this.unpaidBackLink.reduce((sum, item) => {
        return sum + ((item.cost_price || 0) - (parseFloat(item.discount_amount) || 0));
      }, 0);
      // Trigger grand total calculation
      this.calculateGrandTotal();
    },

    /**
     * Update discount information for a specific backlink and sync with backend
     * Calculates discount_amount based on discount_type:
     * - flat: discount_amount = discount_value
     * - percentage: discount_amount = (discount_value / 100) * cost_price
     * @param {object} backlink - The backlink object with updated discount values
     */
    async updateBackLinkDiscount(backlink) {
      try {
        // Set loading state for this specific backlink
        this.$set(this.backlinksLoadingState, backlink.id, true);

        // Calculate discount_amount based on discount_type
        let calculatedDiscountAmount = 0;
        if (backlink.discount_type === 'flat') {
          // For flat discount, amount equals the value
          calculatedDiscountAmount = backlink.discount_value || 0;
        } else if (backlink.discount_type === 'percentage') {
          // For percentage discount, calculate from cost_price
          calculatedDiscountAmount = ((backlink.discount_value || 0) / 100) * (backlink.cost_price || 0);
          calculatedDiscountAmount = parseFloat(calculatedDiscountAmount.toFixed(2));
        }

        // Prepare the payload for API request
        const payload = {
          discount_type: backlink.discount_type || null,
          discount_value: backlink.discount_value || 0,
          discount_amount: calculatedDiscountAmount,
        };

        // Make API call to backend to update backlink discount
        const response = await this.$api.put(
          `/api/backlinks/${backlink.id}/discount`,
          payload
        );

        // Update original discount state to disable button after successful save
        this.$set(this.backlinksOriginalDiscount, backlink.id, {
          discount_type: backlink.discount_type || "",
          discount_value: backlink.discount_value || 0,
          discount_amount: backlink.discount_amount || 0,
        });

        // Clear loading state
        this.$set(this.backlinksLoadingState, backlink.id, false);

        // Show success notification
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Backlink discount updated successfully",
          },
        });
      } catch (error) {
        // Clear loading state
        this.$set(this.backlinksLoadingState, backlink.id, false);

        // Show error notification
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "BellIcon",
            variant: "danger",
            text: error?.response?.data?.message || "Failed to update backlink discount",
          },
        });
      }
    },

    async onDelete(row) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Delete " + row?.invoice_number + "?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$api.delete(`/api/outreach-invoices/${row?.id}`);

            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Outreach Invoice Successfully Deleted",
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems();
      }, 1000);
    },

    async getOutreachNicheItems(params) {
      const { startDate, endDate } = formatDateRange(this.filterGeneratedDate);

      return await this.$api.get(
        "api/outreach-invoices?include=seller,backlinks, backlinks.currency",
        {
          params: {
            show: params.show,
            page: params.page,
            sort: params.sort,
            filterWebsite: this.searchTerm,
            filterSelectSellersId: this.filterSelectSellersId,
            filterSelectStatusId: this.filterSelectStatusId,
            filterGeneratedStartDate: startDate,
            filterGeneratedEndDate: endDate,
            filterPaymentMethod: this.filterPaymentMethod,
          },
        }
      );
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    async loadItems() {
      try {
        this.isLoading = true;
        const outreachNiche = await this.getOutreachNicheItems({
          show: this.serverParams.perPage,
          page: this.serverParams.page,
          sort: this.serverParams.sort,
        });

        const data = outreachNiche?.data?.data;
        const meta = outreachNiche?.data?.meta;

        this.totalRecords = meta?.pagination?.total;
        this.rows = data;

        this.isLoading = false;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
    validationForm: async function () {
      this.$refs.createFormValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.$refs.createFormValidation.reset();
            if (this.modelType == "editModel") {
              this.isSubmitLoading = true;
              await this.$api.put(
                `/api/outreach-invoices/${this.outreachInvoiceId}`,
                {
                  invoice_number: this.invoiceNumberInput,
                  invoice_date: this.invoiceDateInput,
                  seller_id: this.selectSellerId,
                  payment_method: this.selectPaymentId,
                  payment_date: this.paymentDateInput,
                  status: this.selectInvoiceStatusId,
                  payment_details: this.paymentDetailsInput,
                  remarks: this.remarksInput,
                  backlink_id: this.backLinkId,
                  approver_id: this.selectApproverId,
                }
              );
              this.isSubmitLoading = false;
              this.loadItems();

              this.hiddenModal();

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Success",
                  icon: "BellIcon",
                  variant: "success",
                  text: "Outreach Seller Successfully Updated",
                },
              });
            }
          } catch (error) {
            this.isSubmitLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.createFormValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },
    generateInvoiceForm: async function () {
      this.$refs.generateInvoiceForm.validate().then(async (success) => {
        if (success) {
          try {
            if (this.unpaidBackLink.length <= 0) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: "No backlinks selected",
                },
              });
              return;
            }

            this.$refs.generateInvoiceForm.reset();
            this.isSubmitLoading = true;
            const formattedBacklinks = this.unpaidBackLink.map(
              (backlink) => backlink.id
            );

            const payload = {
              payment_method: this.selectPaymentId,
              seller_id: this.generateSellerId,
              payment_date: this.paymentDateInput,
              approver_id: this.selectApproverId,
              backlinks: formattedBacklinks,
              payment_details: this.paymentDetailsInput,
              remarks: this.remarksInput,
              total_amount: this.total_amount,
              fee: this.fee_amount,
              discount_amount: this.discount_amount,
              discount_value: this.discount_value,
              discount_type: this.discount_type,

              fee_value: this.fee_value,
              fee_type: this.fee_type,
            };

            if (this.modelType === "editModel") {
              // For editing, send a PUT request
              await this.$api.put(
                `/api/outreach-invoices/${this.outreachInvoiceId}`,
                payload
              );
            } else if (this.modelType === "reviewModal") {
              // For creating, send a PUT request
              await this.$api.put(
                `/api/outreach-invoices/${this.outreachInvoiceId}/reviewed`,
                payload
              );
            } else {
              // For creating, send a POST request
              await this.$api.post(`/api/outreach-invoices`, payload);
            }

            this.isSubmitLoading = false;
            this.loadItems();

            this.hiddenGenerateModal();
          } catch (error) {
            this.isSubmitLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.generateInvoiceForm.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-flatpicker";

.required-label label::after {
  content: " *";
  color: red;
}

/* Fullscreen mode */
.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Adjust editor and toolbar in fullscreen mode */
.fullscreen .ql-container {
  height: calc(100vh - 50px) !important;
}

.fullscreen .ql-toolbar {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  padding: 10px;
}

/* Fullscreen button styling */
.fullscreen-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
}

/* Discount column styling */
.discount-column {
  min-width: 250px;
  padding: 8px;
}

.discount-column .v-select,
.discount-column .b-form-group {
  font-size: 0.9rem;
}

.input-group-sm .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
}
</style>

